exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.survey-form[data-v-607912e0] {\n    margin: 2rem 0;\n    font-size: 1rem;\n}\n.survey-item[data-v-607912e0] {\n    padding: 1rem 0;\n}\n.content-item[data-v-607912e0] {\n    font-size: 1.25rem;\n}\n.required-icon[data-v-607912e0] {\n    padding-left: 0.25rem;\n}\n", ""]);

// exports
